import { render } from "./EasySteps.vue?vue&type=template&id=572a9a4a&scoped=true"
import script from "./EasySteps.vue?vue&type=script&lang=js"
export * from "./EasySteps.vue?vue&type=script&lang=js"

import "./EasySteps.vue?vue&type=style&index=0&id=572a9a4a&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572a9a4a"]])

export default __exports__